<template>
	<RowAccordion :model="model">
		<template #right>
			<div class="flex items-center mr-3 space-x-2 shrink-0">
				<!-- Filled -->
				<div
					v-for="(_, filledDotsIndex) in row.filledDots"
					:key="`filled-${filledDotsIndex}`"
					class="w-2.5 h-2.5 rounded-full"
					:style="getBgColor(row.trait)"
				/>
				<!-- Empty -->
				<div
					v-for="(_, emptyDotsIndex) in row.emptyDots"
					:key="`empty-${emptyDotsIndex}`"
					class="w-2.5 h-2.5 rounded-full bg-[#3C3D3E]"
				/>
			</div>
		</template>
	</RowAccordion>
</template>

<script>
import personalityResults from '~/mixins/personalityResults'
import { traitColors } from '~/components/Icons/traits'
import RowAccordion from './RowAccordion'

export default {
	name: 'OverlappingTraitsAccordion',
	components: {
		RowAccordion
	},
	mixins: [personalityResults],
	props: {
		row: {
			type: Object,
			required: true
		}
	},
	computed: {
		model() {
			return {
				badgeTrait: this.row.trait,
				title: this.displayTraitName(this.row.trait),
				slogan: this.$t(
					`personality_results.trait.${this.row.trait}.slogan`
				),
				description: this.$t(
					`personality_results.trait.${this.row.trait}.description`
				)
			}
		}
	},
	methods: {
		getBgColor(trait) {
			return { backgroundColor: traitColors[trait] }
		}
	}
}
</script>
